/**
 * Application Routes Configuration
 * Defines all routes and their associated components
 */

import { UserRole } from '../types';

export const ROUTES = {
  // Public routes
  LOGIN: '/login',
  
  // Protected routes - Main
  HOME: '/',
  STATEMENT_RECORDER: '/statements',
  MUTUAL_FUND_RECORDER: '/mutual-funds',
  TRANSACTIONS: '/transactions',
  DASHBOARD: '/dashboard',
  ANALYTICS: '/analytics',
  
  // User Settings (for all staff to change password)
  USER_SETTINGS: '/my-settings',
  
  // Settings routes (Admin)
  SETTINGS: '/setting',
  SETTINGS_COMPANIES: '/setting/companies',
  SETTINGS_COMPANY_DETAIL: '/setting/companies/:companyName',
  SETTINGS_USERS: '/setting/users',
} as const;

export type RouteKey = keyof typeof ROUTES;
export type RoutePath = typeof ROUTES[RouteKey];

/**
 * Role-based default redirect after login
 * Maps each role to their preferred landing page
 */
export const DEFAULT_REDIRECT: Record<UserRole, RoutePath> = {
  [UserRole.ADMINISTRATOR]: ROUTES.TRANSACTIONS,
  [UserRole.STAF_ADMIN]: ROUTES.SETTINGS_COMPANIES,
  [UserRole.STAF_HO]: ROUTES.STATEMENT_RECORDER,
  [UserRole.STAF_FINANCE]: ROUTES.STATEMENT_RECORDER,
};

/**
 * Get the default redirect path for a user role
 */
export const getDefaultRedirect = (role: UserRole): RoutePath => {
  return DEFAULT_REDIRECT[role] || ROUTES.STATEMENT_RECORDER;
};


